import React from 'react';
import { useTranslation } from 'react-i18next';
import { Tooltip } from 'antd';
import { WarningOutlined } from '@ant-design/icons';

import { SubjectCardInEditContainer } from './style';

interface SubjectCardInEditProps {
  /** informacja czy karta przedmiotu jest w edycji */
  inEdition: boolean;
}

/**
 * Komponent wyświetlający informację czy karta przedmiotu jest w edycji
 *
 */
const SubjectCardInEdit = ({ inEdition }: SubjectCardInEditProps): JSX.Element | null => {
  const { t } = useTranslation();

  return inEdition ? (
    <SubjectCardInEditContainer>
      <Tooltip title={t('SUBJECT_CARD_IS_IN_EDIT_TOOLTIP')} placement='left'>
        <span>
          <WarningOutlined />
          <span>{t('SUBJECT_CARD_IS_IN_EDIT')}</span>
        </span>
      </Tooltip>
    </SubjectCardInEditContainer>
  ) : null;
};

export default SubjectCardInEdit;
